import React, { useState, useEffect, useMemo, useCallback } from "react";
import Translations from "../../services/translation.service";
import Call from "../../assets/img/stm-call.svg";
import Data from "../../assets/img/stm-data.svg";

// import Wallet from "../../assets/img/stm-wallet.svg";
import Tag from "../../assets/img/stm-tag.png";
import SummaryOfferSection from "./storefront-summary-offers-section";
import Summaries from "../../services/summaries.service";
import storefront from "../../services/storefront.service";
import Plans from "../../services/plans.service";
import bannerInfinity from "../../assets/img/blackInfinity.svg";
import Storage from "../../services/storage.service";
import StmSummarySkeleton from "../skeleton/storefront-summary";
import * as variables from '../../variables';
import FirebaseAnalytics from "../../services/firebaseAnalytics";

const subscriptions = [];
let prefix = "stm_sum_";
let prefix_general = "stm_general_";

const StmSummary = ({
   appliedOffer,
   setAppliedOffer,
   selectedCard,
   selectedDataPlanData,
   selectedTimePlanData,
   isBuildOwnPlan,
   setOffersFetchedInitially
   }) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loader, setLoader] = useState(true);
  const [numberData, setNumberData] = useState(null);
  const [savedPlans, setSavedPlans] = useState([]);
  const [planPromotions, setPlanPromotions] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [extras, setExtras] = useState([]);
  const [planCode, setPlanCode] = useState("");
  const [planPrice, setPlanPrice] = useState(0);
  const [planPdfsKeys, setPlanPdfsKeys] = useState(JSON.parse(Storage.get('citcPdfForPlans', true)) || {});

  const getPlanDataMinValue = (data, type) => {
    if(data === -1){
      return <img src={bannerInfinity} alt="infinity"/>
    }
    let value = storefront.getPlanDataMinValue(data, type);
    return value;
  };

  const planType = {
    DATA: { type: "Data", unit: "data_unit", label: "data" },
    "VOICE-LCL": { type: "Minute", unit: "minute_unit", label: "minutes" },
  };

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  const getPlanName = (plan_code) => {
    let plan_prefix = "general_plan_name_";
    if (plan_code) {
      return Translations.keys[plan_prefix + plan_code];
    }
  };



  const getSummary = () => {
   return Summaries.getSummary()
    .then((res) => {
      setLoader(false);
      if (res?.data) {
        setSummaryData(res?.data);
        Storage.set("paymentPrice", res?.data?.total_amount_vat_included, true)
        if (res?.data?.saved_plans[0]["Plans"]?.length) {
          setPlanCode(res?.data?.saved_plans[0]["PlanCode"]);
          setSavedPlans(res?.data?.saved_plans[0]["Plans"]);
          setPlanPromotions(res?.data?.saved_plans[0]["PlanPromotions"] || []);

          setPlanPrice(res?.data?.saved_plans[0]["DiscountedPrice"]);
        }
        if (res?.data?.number_details) {
          setNumberData(res?.data?.number_details);
          if(res.data.number_details.MSISDN) {
            Storage.set("number", res.data.number_details.MSISDN, true);
            Storage.set("num_vanity", res.data.number_details.VanityLevelID, true);
          }
        }
        if (res?.data?.extras) {
          setExtras(res?.data?.extras);
        }
      }
    })
    .catch(() => {
      setLoader(false);
    });
  }
  
  useEffect(() => { 
    getSummary()
  }, []);

  useEffect(() => {
    
    Storage.get_obsrv("citcPdfForPlans").subscribe(data => {
      if (!data) {
        setLoader(true);
        Plans.getCITC().then((res) => {
          setLoader(false);
          Storage.clear("citcErrorStatus");
          if (res?.data) {
            setPlanPdfsKeys(res?.data);
            Storage.set(
              "citcPdfForPlans",
              JSON.stringify(res.data),
              true
            );
          }
        }).catch(()=>{
          setLoader(false);
          Storage.clear("citcErrorStatus");
        })
      }
    });
  }, []);


  const getKeysCombination = useCallback((id1, id2) => {
    let key1 = ""
    let key2 = ""
    key1 = `${id1},${id2}`
    key2 = `${id2},${id1}`
    if(id1 && !id2) {
      key1 = id1
      key2 = id1
   }
   if(!id1 && id2) {
     key1 = id2
     key2 = id2
   }
    return {key1, key2}
  },[])

  const pdfUrl = useMemo(()=> {
    const selectedPlanIds = Storage.get("selected_plan_id", true)
    let key = ""
    let reverseKey = ""
    if(selectedCard?.Plan?.length){
      const {key1, key2} = getKeysCombination(selectedCard?.Plan[0]?.PlanID, selectedCard?.Plan[1]?.PlanID)
      key = key1
      reverseKey = key2
    }
    if(isBuildOwnPlan && selectedDataPlanData && selectedTimePlanData) {
      key = `${selectedDataPlanData.ID},${selectedTimePlanData.ID}`
      reverseKey = `${selectedTimePlanData.ID},${selectedDataPlanData.ID}`
    }
    if(selectedPlanIds){
      const ids = selectedPlanIds.split(",")
      key = ids?.length ? `${ids[0]},${ids[1]}` : ""
      reverseKey = ids.length ? `${ids[1]},${ids[0]}`: ""
    }
    const pdfFile = planPdfsKeys[`${key}`] ? planPdfsKeys[`${key}`] : planPdfsKeys[`${reverseKey}`];
    return (pdfFile ? pdfFile : planPdfsKeys[`default`])
  },[selectedCard, planPdfsKeys, isBuildOwnPlan, selectedDataPlanData, selectedTimePlanData, getKeysCombination])


  const numberType = useMemo(()=> {
   return translationKeys[`general_vanity_name_${numberData?.VanityLevelID || 0}number`]
  },[numberData, translationKeys])

  const {addonsValues, dataBonusValues ,minutesBonusValues} = useMemo(()=>{
    const freeAddons = []
    const dataBonus = []
    const minutesBonus = []
    const freePlanPromotions = planPromotions?.filter(promotion => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN);
    for (let promotion of freePlanPromotions) {
      const parsed = JSON.parse(promotion["Value"]);
      switch (parsed.Type) {
        case variables.PROMOTION_TYPE_VOICE_ON_NET:
        case variables.PROMOTION_TYPE_DATA_SOCIAL:
          freeAddons.push(parsed);
          break;
        case variables.PROMOTION_TYPE_DATA:
          dataBonus.push(parsed);
          break;
        case variables.PROMOTION_TYPE_VOICE_LCL:
          minutesBonus.push(parsed);
          break;
        default:
      }
    }
    let dataBonusValues = Plans.getSumData(dataBonus, variables.PROMOTION_TYPE_DATA, "gb");
    let minutesBonusValues = Plans.getSumData(minutesBonus, variables.PROMOTION_TYPE_VOICE_LCL, "min");
    let addonsValues = Plans.getSumData(freeAddons, variables.PROMOTION_TYPE_DATA_SOCIAL, "gb")

return {addonsValues, dataBonusValues ,minutesBonusValues}
  },[planPromotions])


  return (
      loader ? (
        <StmSummarySkeleton />
      ) : (
        <div className="summary-stm-main">
        <div className="summary-stm-wrapper">
          <div className="stm-sum-grid stm-sum-grid-top">
            <h3 className="stm-sum-block-left">
              {translationKeys[prefix + "summary"]}
            </h3>
            
            {!!pdfUrl && <div className="package-btn">
              <button className="package-btn"
              onClick={() => {
                FirebaseAnalytics.button_clicked(
                  translationKeys[prefix + "package_card"]
                )
              }}>
              <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
              {translationKeys[prefix + "package_card"]}
              </a>
              </button>
            </div>}
          </div>
          <p className="desc">{translationKeys[prefix + "num_disc"]}</p>
          <div className="stm-sum-data-box">
            {numberData && (
              <>
              <div className="stm-sum-grid">
                <div className="stm-sum-block-left stm-sum-logo">
                  <img src={Call} alt="call" />
                  <span>{translationKeys[prefix + "your_number"]}</span>
                </div>
                <div className="stm-sum-block-right">{numberData?.Price > 0 ? `${numberData?.Price} ${translationKeys[prefix_general + "currency"]}` : translationKeys[prefix + "free"]}</div>

                <div className="stm-sum-block-left">{numberType}</div>
                <div className="stm-sum-block-right">{numberData?.MSISDN}</div>
              </div>
              <hr />
              </>
            )}
            {!!savedPlans.length && (
              <>
                <div className="stm-sum-grid">
                  <div className="stm-sum-block-left stm-sum-logo">
                    <img src={Data} alt="" />
                    <span>{getPlanName(planCode) || planCode}</span>
                  </div>
                  <div className="stm-sum-block-right">
                    {planPrice}{" "}
                    {" " + translationKeys[prefix_general + "currency"]}
                  </div>
                  {savedPlans.map((plan) => {
                    const value = getPlanDataMinValue(
                      plan.Value,
                      planType[plan.Type]?.type
                    )
                    return(
                    <React.Fragment key={plan.ID}>
                      <div className="stm-sum-block-left">
                        {translationKeys[
                          prefix_general + planType[plan.Type]?.label
                        ] + " "}
                      </div>
                      <div className="stm-sum-block-right">
                      {((planType[plan.Type]?.type === "Data" && dataBonusValues < 0) || (planType[plan.Type]?.type === "Minute" && minutesBonusValues < 0) || value < 0) ?
                       <img src={bannerInfinity} alt="infinity"/> : (planType[plan.Type]?.type === "Data" && dataBonusValues > 0) ? 
                       <span>{`(${value} + ${dataBonusValues}) = ${value+dataBonusValues}`}{" "}</span> : 
                       (planType[plan.Type]?.type === "Minute" && minutesBonusValues > 0) ? 
                       <span>{`(${value} + ${minutesBonusValues}) = ${value+minutesBonusValues}`}</span> : <span>{value}</span>}
                      {" "}<span className="unit">{translationKeys[prefix_general + planType[plan.Type]?.unit]}</span>
                      </div>
                    </React.Fragment>
                  )})}
                  {addonsValues !== 0 && <>
                    <div className="stm-sum-block-left">
                    {Translations.keys['free_addons_lbl_DATA-SOCIAL']}
                      </div>
                      <div className="stm-sum-block-right">
                      {addonsValues === -1 ? <img src={bannerInfinity} alt="infinity"/> : addonsValues}
                       {translationKeys[prefix_general + "data_unit"]}
                      </div>
                      </>}
                </div>
                <hr />
              </>
            )}
            <div className="stm-sum-content-title">
              <div className="stm-sum-block-left stm-sum-logo">
                <img src={Tag} alt="" />
                <span>{translationKeys[prefix + "offers"]}</span>
              </div>
            </div>
            <SummaryOfferSection
              getSummary={getSummary}
              selectedCard={selectedCard}
              appliedOffer={appliedOffer}
              setAppliedOffer={setAppliedOffer}
              setOffersFetchedInitially={setOffersFetchedInitially}
            />
            <hr />
            {!!extras.length && (
              <>
                {/* <div className="stm-sum-content-title">
                  <div className="stm-sum-block-left stm-sum-logo">
                    <img src={Wallet} alt="" />
                    <span>{translationKeys[prefix + "extras"]}</span>
                  </div>
                </div>
                <div className="stm-sum-grid">
                  <div className="stm-sum-block-left">
                    {translationKeys[prefix + "wallet_top_up"]}
                  </div>
                  <div className="stm-sum-block-right">
                    25 {" " + translationKeys[prefix_general + "currency"]}
                  </div>
                </div>
                <hr />{" "} */}
              </>
            )}
            <div className="stm-sum-grid  stm-sum-grid-payment">
              <div className="payment-sum-right">
                {translationKeys[prefix + "payment_amount"]}
              </div>
              <div className="payment-sum-left">
                {summaryData?.total_amount_vat_excluded}{" "}
                {" " + translationKeys[prefix_general + "currency"]}
              </div>

              <div className="payment-sum-right">
                {translationKeys[prefix + "vat"]} (
                {(
                  (summaryData?.vat_amount /
                    summaryData?.total_amount_vat_excluded) *
                    100 || 0
                ).toFixed(2)}
                %)
              </div>
              <div className="payment-sum-left">
                {summaryData?.vat_amount}
                {" " + translationKeys[prefix_general + "currency"]}{" "}
              </div>

              <div className="stm-sum-block-left stm-sum-logo">
                {translationKeys[prefix + "total_amount"]}
              </div>
              <div className="stm-sum-block-right">
                {summaryData?.total_amount_vat_included}{" "}
                {" " + translationKeys[prefix_general + "currency"]}
              </div>
            </div>
          </div>
        </div>    </div>

      )
  );
};

export default StmSummary;
